<template>
  <div class="tableClass">
    <!-- grid + 分页 -->
    <el-table
      :data="gridData"
      :size="gridConfig.size"
      :border="gridConfig.border"
      style="width:100%"
      :height="height"
      :max-height="maxHeight"
      :stripe="false"
      v-loading="gridConfig.loading"
      :show-header="gridConfig.showHeader"
      :fill="gridConfig.fill"
      :header-cell-style="gridConfig.headerCellStyle"
      :cell-style="gridConfig.cellStyle"
      @row-click="rowClick"
      @sort-change="sortChange"
      @select-all="handleSelectAll"
      @select="handleSelect"
      @selection-change="handleSelectionChange"
      :span-method="gridConfig.arraySpanMethod"
      :show-summary="gridConfig.showSummary"
      :summary-method="gridConfig.summaryMethod"
      :highlight-current-row="highlightCurrentRow"
      :row-style="rowStyleFunc?rowStyleFunc:selectedHighlight"
      :row-class-name="rowClassName"
      :empty-text="gridConfig.emptyText"
      :ref="tableRef"
    >
      <el-table-column v-if="gridConfig.multiSelect" type="selection" align="center"
                       width="50"/>
      <el-table-column type="expand" v-if="gridConfig.showExpand">
        <template slot-scope="props">
          <slot name="expand" :data="props.row"/>
        </template>
      </el-table-column>
      <el-table-column v-if="gridConfig.hasIndex" type="index" align="center" :index="indexMethod"
                       label="序号"
                       width="60"/>
      <mx-column v-if="gridColumns && gridColumns.length > 0 " v-for="(column, index) in gridColumns" :column="column"
                 :key="index">
        <template v-if="column.customSlots && column.customSlots.content" v-slot:[column.customSlots.content]="scope">
          <slot :name="column.customSlots.content" :row="scope.row" :column="scope.column" :$index="scope.$index"/>
        </template>
        <template v-if="column.customSlots && column.customSlots.header" v-slot:[column.customSlots.header]="scope">
          <slot :name="column.customSlots.header" :row="scope.row" :column="scope.column" :$index="scope.$index"/>
        </template>
      </mx-column>
    </el-table>
    <!-- 分页 -->
    <!-- 会员服务分页 -->
    <div class="bottom-pagination" v-if="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="currentChange"
        :current-page="pagination.page"
        :page-sizes="pagination.sizes || [100,200,500,1000]"
        :page-size="pagination.size"
        background
        :layout="pagination.layout || 'total, sizes, prev, pager, next, jumper'"
        :total="pagination.total"
        :pager-count="pagination.pagerCount || pagination['pager-count'] || 7"
      />
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import MxColumn from './column'
import {getDoctorVersion} from '@/utils/cookie'

export default {
  components: {
    MxColumn
  },
  data() {
    return {
      selection: []
    }
  },
  props: {
    singleSelect: {
      type: Boolean,
      default: false
    },
    tableRef: {
      type: String,
      default: 'mxTable'
    },
    gridData: {
      type: Array
    },
    gridConfig: {
      type: Object
    },
    gridColumns: {
      type: Array
    },
    pagination: {
      type: Object
    },
    fetch: {
      type: Function
    },
    /* ***** 父组件是子组件时，table的高度 ******/
    dashboardHeight: {
      type: Number | String,
      default: 0
    },
    rowStyleFunc: {
      type: Function
    },
    headStyleFunc: {
      type: Function
    },
    maxHeight: {
      type: String | Number
    },
    highlightCurrentRow: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    // 深度监听，可监听到对象、数组的变化
    gridColumns: {
      handler(val, oldVal) {
        this.$refs[this.tableRef].doLayout()
      },
      // true 深度监听
      deep: true
    }
  },
  computed: {
    ...mapGetters([
      'mainDOMRect'
    ]),
    mainHeight() { // main区域高度
      return this.mainDOMRect.height
    },
    height: { // grid 的高度
      get() { // 回调函数 当需要读取当前属性值是执行，根据相关数据计算并返回当前属性的值
        if (typeof this.dashboardHeight === 'string') {
          return this.dashboardHeight
        } else if (this.dashboardHeight > 0) {
          return this.dashboardHeight
        } else {
          if (this.gridConfig.autoHeight) {
            return null
          }
          if (this.gridConfig.isHeaderExist) { // 如果表格存在头部（搜索框、按钮行）
            if (this.gridConfig.topHeight > 0) {
              return this.mainHeight - 223 - this.gridConfig.topHeight
            }
            return this.mainHeight - 223
          } else {
            if (this.gridConfig.topHeight > 0) {
              return this.mainHeight - 163 - this.gridConfig.topHeight
            }
            return this.mainHeight - 163
          }
        }
      },
      set() {
      }
    }
  },
  updated() {
    this.$nextTick(() => {
      this.$refs[this.tableRef].doLayout()
    })
  },
  mounted() {
    this.$parent.gridConfig = Object.assign({
      size: 'mini',
      border: true,
      stripe: true,
      loading: false,
      multiSelect: true,
      hasIndex: true,
      showHeader: true,
      isHeaderExist: true,
      showExpand: false, // 是否开启展开行
      topHeight: 0, /* ** table距离 按钮、搜索栏中间的高度 **/
      initTable: true, // 是否页面一启动就加载数据
      autoHeight: true, // 自动高度
      fill: true
    }, this.gridConfig)
    this.gridConfig.initTable && this.fetch()
  },
  methods: {
    setCurrentRow(row) {
      if (this.singleSelect) {
        this.$refs[this.tableRef].clearSelection()
        this.$refs[this.tableRef].toggleRowSelection(row)
      }
    },
    indexMethod(index) {
      if (this.pagination) {
        return (this.pagination.page - 1) * this.pagination.size + index + 1
      } else {
        return index + 1
      }
    },
    rowClassName({row, rowIndex}) {
      if (!this.gridConfig.stripe) {
        return ''
      }
      if (rowIndex % 2 === 1) {
        return 'mx-table-row-stripe'
      }
      return ''
    },
    sortChange({column, prop, order}) {
      this.$emit('sort-change', {column, prop, order})
    },
    rowClick(row, column, event) {
      this.setCurrentRow(row)
      this.$emit('row-click', {row, column, event})
    },
    handleSelectionChange(selection) {
      this.selection = selection
      this.$emit('selection-change', selection)
    },
    handleSelect(selection, row) {
      this.$emit('select', selection, row)
    },
    handleSelectAll(selection) {
      this.$emit('select-all', selection)
    },
    handleSizeChange(size) {
      this.pagination.size = size
      this.fetch()
    },
    currentChange(currentChange) {
      this.pagination.page = currentChange
      this.fetch()
    },
    toggleRowSelection (row, selected) {
      this.$refs[this.tableRef].toggleRowSelection(row, selected)
    },
    selectedHighlight({row, rowIndex}) {
      if (this.selection.includes(row)) {
        let ver = getDoctorVersion()
        if (ver === 'v1') {
          return {'background-color': 'rgba(191, 161, 107, 0.2)'}
        } else {
          return {'background-color': 'rgba(192, 210, 255, 0.5)'}
        }
      }
    }

  }
}
</script>
<style lang="scss" scoped>
  .tableClass {
    .el-table th {
      background: #E4E7ED !important;
    }

    .el-table--border th.gutter:last-of-type {
      border-bottom: 1px solid #ebeef5;
      border-bottom-width: 1px;
      border-right: 0px;
      background: #fff !important;
    }

    // 单元格图片间距
    .el-table {
      .el-table__body {
        .el-table__row {
          .cell {
            img + img {
              margin-left: 10px !important;
            }
          }
        }
      }
    }
  }
  /deep/ .mx-table-row-stripe{
    background: rgba(244, 247, 255, 0.5);
  }
</style>



// WEBPACK FOOTER //
// src/components/Table/MxTable/index.vue